import React from 'react';
import TalentShow2024 from 'views/TalentShow2024';

const AccountGeneralPage = () => {
  return <TalentShow2024/>;
};

export default AccountGeneralPage;